import { render, staticRenderFns } from "./SocketIoClient.vue?vue&type=template&id=29fb2c4c&"
import script from "./SocketIoClient.vue?vue&type=script&lang=js&"
export * from "./SocketIoClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports